import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Spinner, TextArea } from "@blueprintjs/core";

import { LinkButton } from "@components";
import { OrgContext } from "@providers";

import { PolicyWithRules } from "../types";
import { onUpdatePolicy } from "../utils";

type Props = {
  workingPolicy: PolicyWithRules;
  refreshPolicies: () => void;
};

const Description = styled.div`
  margin: var(--global-spacing-l) 0;
`;

const DescriptionTextArea = styled(TextArea)`
  &.bp3-input {
    padding: 0 4px;
  }
`;

const EditButton = styled(LinkButton)`
  padding: 0;
`;

export const PolicyDescription: React.FC<Props> = ({
  workingPolicy,
  refreshPolicies,
}) => {
  const { org } = useContext(OrgContext);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [description, setDescription] = useState<string>(
    workingPolicy.description
  );
  const [isSaving, setIsSaving] = useState<boolean>(false);

  return (
    <Description>
      {editMode ? (
        <>
          <DescriptionTextArea
            fill
            value={description}
            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
              setDescription(event.target.value);
            }}
          />
          {isSaving ? (
            <Spinner intent="primary" />
          ) : (
            <LinkButton
              onClick={() => {
                onUpdatePolicy(
                  org!,
                  { ...workingPolicy, description: description },
                  setIsSaving,
                  () => {},
                  refreshPolicies
                )();
                setEditMode(false);
              }}
            >
              Save
            </LinkButton>
          )}
          <LinkButton
            onClick={() => {
              setEditMode(false);
              setDescription(workingPolicy.description);
            }}
          >
            Discard
          </LinkButton>
        </>
      ) : (
        <>
          <div>{description}</div>
          <EditButton onClick={() => setEditMode(true)}>Edit</EditButton>
        </>
      )}
    </Description>
  );
};
